import { axios } from '@/lib/axios';

export const createInvoice = async (id: any, data: any) => {
    const { success, message } = await axios.post(`v1/create-invoice`, data);

    return { success, message };
};
